import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/data';

export default function HomeHero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20warm%20coral%20and%20cream%20gradients%2C%20soft%20flowing%20shapes%2C%20minimalist%20modern%20design%2C%20clean%20elegant%20background%2C%20subtle%20texture%2C%20professional%20website%20hero%20aesthetic%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=home-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="flex items-center justify-center gap-2 mb-4">
          <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-primary-500/90 text-background-50 rounded-xl backdrop-blur-sm">
            <i className="ri-shield-check-line text-xl md:text-2xl"></i>
          </div>
        </div>

        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 font-heading leading-tight max-w-3xl mx-auto mb-4">
          {siteConfig.tagline}
        </h1>

        <p className="text-sm md:text-base text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          精选全球合规成人免费网站资源，涵盖健康性教育、情感科普、合法影音平台等内容，
          帮助成年用户安全、私密、高效地找到所需正规资源，拒绝风险链接，保障隐私安全。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/sex-education"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            开始浏览资源
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-background-50/15 text-background-50 backdrop-blur-sm rounded-md text-sm font-medium hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer border border-background-50/20"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { value: '500+', label: '收录资源' },
            { value: '12', label: '资源分类' },
            { value: '50,000+', label: '日均访问' },
            { value: '98.6%', label: '好评率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-300/80 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-2">
          <span className="flex items-center gap-1 text-xs text-background-300/70">
            <i className="ri-lock-line"></i>
            全程HTTPS加密
          </span>
          <span className="text-background-400/50">·</span>
          <span className="flex items-center gap-1 text-xs text-background-300/70">
            <i className="ri-eye-off-line"></i>
            不追踪隐私
          </span>
          <span className="text-background-400/50">·</span>
          <span className="flex items-center gap-1 text-xs text-background-300/70">
            <i className="ri-check-double-line"></i>
            人工审核
          </span>
        </div>
      </div>
    </section>
  );
}